export default __webpack_public_path__ + "static/media/hero-bg-p.aad6fd1c.jpg";